/** Shared Agent/Tasks composer copy missing from the current system catalog. */
export const editorLiterals = {
  expand: { key: 'chat_composer_expand_input', fallback: { en: 'Expand message input', he: 'הרחבת שדה ההודעה' } },
  collapse: { key: 'chat_composer_collapse_input', fallback: { en: 'Collapse message input', he: 'צמצום שדה ההודעה' } },
} as const

export const dictationLiterals = {
  starting: { key: 'chat_composer_dictation_starting', fallback: { en: 'Starting…', he: 'מתחיל…' } },
  recording: { key: 'chat_composer_dictation_recording', fallback: { en: 'Recording', he: 'מקליט' } },
  cancelHint: { key: 'chat_composer_dictation_cancel_hint', fallback: { en: 'Esc to cancel', he: 'Esc לביטול' } },
} as const

export const missingChatComposerLiteralKeys = [
  ...Object.values(editorLiterals),
  ...Object.values(dictationLiterals),
].map(({ key }) => key)
